export const LISTMONK_LIST_UUID = "afa25570-e93f-4868-a19d-0d654289f86a"
